import React from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';

import { i18n } from './i18n';

export type Locale = 'ar' | 'en';

export const I18nProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export { useTranslation };
